"use client";

import { useEffect, useState } from "react";

export const dynamic = "force-dynamic";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const isDev = process.env.NODE_ENV !== "production";
  // El estado de red se evalúa al montar — `navigator.onLine` puede
  // ser falso (captive portal) pero si el error fue desencadenado por
  // un fetch caído, casi siempre coincide con offline real. Si es
  // false, mostramos copy específico de "sin conexión" en vez del
  // genérico — evita asustar al usuario en un escenario esperado
  // (faltaba una API no cacheada).
  const [isOffline, setIsOffline] = useState(false);

  useEffect(() => {
    setIsOffline(typeof navigator !== "undefined" && !navigator.onLine);
    // eslint-disable-next-line no-console
    console.error("[GlobalError]", error);
  }, [error]);

  const title = isOffline ? "Sin conexión" : "Algo salió mal";
  const description = isOffline
    ? "Esta página necesita datos del servidor que aún no están cacheados. Ve al inicio y vuelve cuando recuperes la red — los cambios pendientes se sincronizarán automáticamente."
    : isDev
      ? "Error en dev:"
      : "Se produjo un error inesperado en la aplicación.";

  return (
    <html lang="es">
      <body style={{ fontFamily: "system-ui, sans-serif", backgroundColor: "#f9fafb", margin: 0 }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            gap: "1rem",
            padding: "2rem",
          }}
        >
          <h2 style={{ fontSize: "1.25rem", fontWeight: 600, color: "#1f2937", marginBottom: 0 }}>
            {title}
          </h2>
          <p style={{ fontSize: "0.875rem", color: "#6b7280", margin: 0, textAlign: "center", maxWidth: 480 }}>
            {description}
          </p>

          {isDev && !isOffline && (
            <pre
              style={{
                background: "#1f2937",
                color: "#f9fafb",
                padding: "1rem",
                borderRadius: "0.5rem",
                fontSize: "0.75rem",
                maxWidth: 720,
                maxHeight: 320,
                overflow: "auto",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
              }}
            >
              {error?.message}
              {"\n\n"}
              {error?.stack}
            </pre>
          )}

          <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap", justifyContent: "center" }}>
            <button
              onClick={reset}
              style={{
                padding: "0.5rem 1.5rem",
                borderRadius: "0.5rem",
                border: "none",
                backgroundColor: "#1565A0",
                color: "#fff",
                fontSize: "0.875rem",
                fontWeight: 500,
                cursor: "pointer",
              }}
            >
              {isOffline ? "Reintentar" : "Intentar de nuevo"}
            </button>
            {isOffline && (
              <button
                onClick={() => {
                  if (typeof window !== "undefined") window.location.href = "/";
                }}
                style={{
                  padding: "0.5rem 1.5rem",
                  borderRadius: "0.5rem",
                  border: "1px solid #1565A0",
                  backgroundColor: "#fff",
                  color: "#1565A0",
                  fontSize: "0.875rem",
                  fontWeight: 500,
                  cursor: "pointer",
                }}
              >
                Ir al inicio
              </button>
            )}
          </div>
        </div>
      </body>
    </html>
  );
}
